import React, { Fragment, useState } from "react";
import styled from "styled-components";
import Button from "../Button";
import ExportSamples from "./ExportSamples";

const Container = styled.div`
  padding: 10px;
`;

export default function ExportActionBar({ sampleIds, clientView = true }) {
  const [exporting, setExporting] = useState(false);

  sampleIds = sampleIds || [];

  const _baseUrl = () => {
    return window.location.protocol + "//" + window.location.host;
  };

  return (
    <Container>
      {
        <Button
          tiny
          title={I18n.t("export_samples")}
          onClick={() => setExporting(!exporting)}
        />
      }
      {exporting && <ExportSamples sampleIds={sampleIds} clientView={clientView} />}
    </Container>
  );
}
